import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const authBaseEndpoint = ENDPOINTS.CATERINGEVENT;

// Event API using Catering Package endpoints
export const eventApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["cateringEvent"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getCateringEvent: builder.query({
        query: () => `${authBaseEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "cateringEvent" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      sendEventQuoteMail: builder.mutation({
        query: ({ id }) => ({
          url: `${authBaseEndpoint}send-quote-email/${id}`,
          method: METHODS.POST,
        }),
        // invalidatesTags: () => [{ type: "cateringEvent" }],
      }),
      updateEventQuote: builder.mutation({
        query: ({ id, requestData }) => ({
          url: `${authBaseEndpoint}save-quote/${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "cateringEvent" }],
      }),
    }),
  });

// Export hooks for usage in components

export const {
  useGetCateringEventQuery,
  useUpdateEventQuoteMutation,
  useSendEventQuoteMailMutation,
} = eventApi;
